module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/MZ-c4535e0fabdd5ff8431de9bc05bc8914.png";